"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var ExportedEntityState_1 = require("./ExportedEntityState");
/**
 * Representation of an entity in export queue.
 *
 * @author Radek Beran
 * @author VRu
 */


var ExportedEntity =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ExportedEntity, _DomainObject_1$Domai);

  /**
   * Creates new exported entity.
   * @param id identifier of record in the queue
   * @param state state of export
   * @param created time of creation of record
   * @param createdBy user who created this record
   * @param lastModified time of last modification of this record
   * @param nextAttempt time of next planned export attempt
   * @param attemptCount count of attempts, starts with 0; 1 after first successful of failed attempt
   * @param requestId request id returned from IDB
   * @param error description of last error if this record is in failed state
   * @param processId ID of application instance that is responsible for export
   */
  function ExportedEntity(id, state, created, createdBy, lastModified, nextAttempt, attemptCount, requestId, error, processId) {
    var _this;

    _classCallCheck(this, ExportedEntity);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExportedEntity).call(this));
    _this.id = id;
    _this.state = state;
    _this.created = created;
    _this.createdBy = createdBy;
    _this.lastModified = lastModified;
    _this.nextAttempt = nextAttempt;
    _this.attemptCount = attemptCount;
    _this.requestId = requestId;
    _this.error = error;
    _this.processId = processId;
    return _this;
  }
  /**
   * @returns Aggregated {@link ExportedEntityAggregatedState} based on {@link ExportedEntity this}.
   * @see {@link ExportedEntityAggregatedState} for more info about how the state is resolved.
   */


  _createClass(ExportedEntity, [{
    key: "aggregatedState",
    value: function aggregatedState() {
      switch (this.state) {
        case ExportedEntityState_1.ExportedEntityState.Processing:
        case ExportedEntityState_1.ExportedEntityState.Running:
        case ExportedEntityState_1.ExportedEntityState.Waiting:
          return ExportedEntityState_1.ExportedEntityAggregatedState.Pending;

        case ExportedEntityState_1.ExportedEntityState.Failed:
          return ExportedEntityState_1.ExportedEntityAggregatedState.Failed;

        case ExportedEntityState_1.ExportedEntityState.Success:
          return ExportedEntityState_1.ExportedEntityAggregatedState.Succeeded;

        case ExportedEntityState_1.ExportedEntityState.Closed:
          return this.error ? ExportedEntityState_1.ExportedEntityAggregatedState.Failed : ExportedEntityState_1.ExportedEntityAggregatedState.Succeeded;
      }
    }
  }]);

  return ExportedEntity;
}(DomainObject_1.DomainObject);

exports.ExportedEntity = ExportedEntity;